module.exports = __webpack_public_path__ + "img/ocean_bg_mobile.7175d056.png";